import Icon from '@ant-design/icons';
import { Typography } from 'antd';
import styled, { css } from 'styled-components';
import RightIcon from '../../icons/mobility/rightIcon.svg';
import { type AnchorProps } from '../context';
import themeTokens from './themeTokens';

const colorAndVariantCss = css`
    &.variant-solid {
        &.color-primary {
            color: white;
            background-color: ${themeTokens.primaryColor};
            border: 1px solid ${themeTokens.primaryColor};

            &:hover,
            &:focus,
            &:active {
                background-color: ${themeTokens.hoveredPrimaryColor};
                border-color: ${themeTokens.hoveredPrimaryColor};
            }
        }

        &.color-secondary {
            color: white;
            background-color: ${themeTokens.secondaryColor};
            border: 1px solid ${themeTokens.secondaryColor};

            &:hover,
            &:focus,
            &:active {
                background-color: ${themeTokens.hoveredSecondaryColor};
                border-color: ${themeTokens.hoveredSecondaryColor};
            }
        }

        &.color-tertiary {
            color: ${themeTokens.textColor};
            background-color: white;
            border: 1px solid ${themeTokens.tertiaryColor};

            &:hover,
            &:focus,
            &:active {
                background-color: ${themeTokens.hoveredTertiaryColor};
                border-color: ${themeTokens.hoveredTertiaryColor};
            }
        }
    }

    &.variant-ghost {
        display: inline-flex;
        flex-wrap: nowrap;
        height: auto;
        margin: 0;
        align-items: center;

        &.color-primary,
        &.color-secondary,
        &.color-tertiary {
            color: ${themeTokens.textColor};
            background-color: transparent;
            border: none;

            &:hover,
            &:focus,
            &:active {
                color: ${themeTokens.hoveredLinkColor};
            }
        }
    }
`;

const Base = styled(Typography.Link).withConfig({
    shouldForwardProp: prop => !['porscheFallbackIcon', 'porscheFallbackIconSource'].includes(prop),
    displayName: 'PorscheAnchor',
})<AnchorProps>`
    font-size: var(--button-font-size, 1rem);

    & > .porsche-arrow {
        font-size: 1.5rem;
        width: 1.5rem;
        height: 1.5rem;
    }

    & > .porsche-arrow + span,
    & > span + .porsche-arrow {
        margin-left: 0px;
        width: 100%;
        line-height: 1.5rem;
        transform: translateY(1px);
    }

    ${colorAndVariantCss}
`;

const Anchor = ({
    colorSet = 'primary',
    icon = <Icon className="porsche-arrow" component={RightIcon} />,
    variant = 'ghost',
    children,
    ...rest
}: AnchorProps) => (
    <Base {...rest} className={[`color-${colorSet}`, `variant-${variant}`].join(' ')}>
        {icon}
        <span className="text">{children}</span>
    </Base>
);
export default Anchor;
